// extracted by mini-css-extract-plugin
export default {"card":"Share_card__cp1p7","share":"Share_share__B1rIs","btnGroup":"Share_btnGroup__ZOSTN","avatar":"Share_avatar__wzMKx","modal__image":"Share_modal__image__txjEH"};